import { render, staticRenderFns } from "./channelSummary.vue?vue&type=template&id=dbdd16c0&"
import script from "./channelSummary.vue?vue&type=script&lang=js&"
export * from "./channelSummary.vue?vue&type=script&lang=js&"
import style0 from "./channelSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbdd16c0')) {
      api.createRecord('dbdd16c0', component.options)
    } else {
      api.reload('dbdd16c0', component.options)
    }
    module.hot.accept("./channelSummary.vue?vue&type=template&id=dbdd16c0&", function () {
      api.rerender('dbdd16c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/channelSummary.vue"
export default component.exports